<template>
    
    <section v-if="job && stop">
        <div class="header">
            <h3 class="title">
                Job {{job.job_number}} - stop {{stop.order}}
                <p style="font-size:17px">{{stop.location.long_name}}</p>      
            </h3>
        </div>
        <div class="body">
            <div class="row">
            <h4>
                Arrived Actions
            </h4>
                <br />
                <span v-if="!(stopHasArrivalAction)">
                    <em>No stop arrival actions</em>
                </span>
                <table v-else>
                    <tr v-for="(action, i) in stop.job_stop_actions" :key="i" >
                        <template v-if="action.stop_status_id === 4">
                            <td>
                                <div class="column_rows">       
                                    <p v-if="action.description">
                                        <strong>{{action.button_text}}: &nbsp;</strong>
                                        {{action.description}}
                                    </p>
                                </div>
                                <div class="column_rows">
                                    <p v-if="action.date_completed">
                                        <strong>Completed: &nbsp;</strong> {{action.date_completed | formatDate}}
                                    </p>
                                    <p v-if="!action.date_completed">
                                        <strong>Completed: &nbsp;</strong> <em>Pending</em>
                                    </p>
                                </div>
                                <div class="column_rows">
                                    <p v-if="action.type_data && action.type_data.notes">
                                        <strong>Notes: &nbsp;</strong>
                                        {{ action.type_data.notes }}
                                    </p>
                                </div>
                                <div class="column_rows">
                                    <p v-if="action.type_data && action.type_data.items">
                                        <strong>Items ({{action.type_data.items.length}}): &nbsp;</strong>
                                        <span class="items" v-on:click ="showItemComponentModal(job.job_number, action.type_data.items)">
                                            {{itemStatus(action.type_data.items)}}
                                        </span>
                                    </p>
                                </div>
                                <div class="column_rows">
                                    <p v-if="action.attachments">
                                        <strong>Attachments:&nbsp;</strong>
                                        <span v-for="(attachment, i) in action.attachments" :key ="i">
                                            <span class="attachment" v-on:click ="showDynamicComponentModal(attachment.url, attachment.type)" > {{action.type.attachment_name || action.type.display}}</span>
                                        </span>
                                    </p>
                                </div>
                            </td>
                        </template>                        
                    </tr>
                </table>
            <br /><br />
            <h4>
                Completed Actions
            </h4>
                <br />
                <span v-if="!(stopHasCompletedAction)">
                    <em>No stop completed actions</em>
                </span>
                <table v-else>
                    <tr v-for="(action, i) in stop.job_stop_actions" :key="i" >
                        <template v-if="action.stop_status_id === 5">
                            <td>
                                <div class="column_rows">
                                    <p v-if="action.description">
                                        <strong>{{action.button_text}}: &nbsp;</strong>
                                        {{ action.description}}
                                    </p>
                                </div>
                                <div class="column_rows">
                                    <p v-if="action.date_completed">
                                        <strong>Completed:  &nbsp;</strong> {{action.date_completed | formatDate}}
                                    </p>
                                    <p v-if="!action.date_completed">
                                        <strong>Completed: &nbsp;</strong> <em>Pending</em>
                                    </p>
                                </div>
                                <div class="column_rows">
                                    <p v-if="action.type_data && action.type_data.notes">
                                        <strong>Notes:  &nbsp;</strong>
                                        {{ action.type_data.notes }}
                                    </p>
                                </div>
                                <div class="column_rows">
                                    <p v-if="action.type_data && action.type_data.items &&action.type_data.items.length !== 0">
                                        <strong>Items ({{action.type_data.items.length}}):  &nbsp;</strong>
                                        <span class="items" v-on:click ="showItemComponentModal(job.job_number, action.type_data.items)">
                                            {{itemStatus(action.type_data.items)}}
                                        </span>
                                    </p>
                                </div>
                                <div class="column_rows">
                                    <p v-if="action.attachments">
                                        <strong>Attachments: &nbsp;</strong>
                                        <span v-for="(attachment, i) in action.attachments" :key="i">
                                            <span class="attachment" v-on:click ="showDynamicComponentModal(attachment.url, attachment.type)" > {{action.type.attachment_name || action.type.display}}</span>
                                        </span>
                                    </p>
                                </div>
                            </td>
                        </template>
                    </tr>
                </table>
                    
            </div>
        </div>
    </section>
</template>
<script>
import JobService from '@/components/job/service'
import attachmentModal from './AttachmentForJobModal.vue'
import itemsModal from './ItemsForJobModal.vue'
import JobStopService from './service'

const $body = document.querySelector('body');

export default {
    name: 'JobStopAction',
    data (){
        return{
            job: null,
            stop: null,
            stopActions: null,
            show: true,
        }
    },
    beforeCreate(){
        let job_id = this.$route.params.id;
        let stop_id = this.$route.params.stop_id;
        JobService.getJob(job_id, (err, job) => {
        this.job = job;
        for(let i = 0 ; i <job.stops.length; i++){
            if(parseInt(stop_id) === parseInt(job.stops[i].job_stop_id)){
                this.stop = job.stops[i];
                break;
            }
        }
        this.stopActions = this.stop.job_stop_actions;
        })   
    },
    computed:{
        stopHasArrivalAction(){
            const stop = this.stop;
            if(!stop){
                return false;
            }
            const stop_actions = stop.job_stop_actions; 
            let action = this.action;

            let has_actions= false;
            if (stop_actions && stop_actions){
                for (let i in stop_actions){
                    action = stop_actions[i];
                    if(action.stop_status_id === 4){
                        has_actions = true;
                        break;
                    }
                }
            }
            return has_actions;
        },
        stopHasCompletedAction(){
            const stop = this.stop;

            if(!stop){
                return false;
            }
            const stop_actions = stop.job_stop_actions;
            let action = this.action;
            let has_actions= false;
            if (stop_actions && stop_actions){
                for (let i in stop_actions){
                    action = stop_actions[i];
                    if(action.stop_status_id === 5){
                        has_actions = true;
                        break;
                    }
                }
            }
            return has_actions;
        },
    
    },
    methods: {
        showDynamicComponentModal(url, attachment_type) {
            this.$modal.show(attachmentModal, {
                url: url,
                attachment_type: attachment_type,
                modal : this.$modal},{
                    name: 'attachment',
                    width: '90%',
                    height: 'auto',
            })
        },
        showItemComponentModal(job_number, items){
            this.$modal.show(itemsModal, {
                items: items,
                job_number: job_number,
                modal : this.$modal},{
                    name: 'itemsModal',
                    width: '90%',
                    height: 'auto',},
                    {
                'before-open': this.disableScroller,
                'before-close': this.enableScroller,
            })

        },
        itemStatus(items){
            let accept = 0;
            let reject = 0;
            for(let i = 0; i<items.length; i++){
                if(items[i]._status.status_id === "accepted"){
                    accept += 1;
                }
                else{
                    reject += 1;
                }
            }
            return `Accepted ${accept}, Rejected ${reject}`;
        

        },
        setToActive(job_stop_action_id){
            let stop = this.stop;
            JobStopService.setJobStopActionStatus(this.stop.job_stop_id, job_stop_action_id, 1, function(err, actions){
                if(actions){
                    stop.job_stop_actions = actions;
                    
                }
            })

        },
        setToInactive(job_stop_action_id){
            let stop = this.stop
            JobStopService.setJobStopActionStatus(this.stop.job_stop_id, job_stop_action_id, 0, function(err, actions){
                if (actions){
                    stop.job_stop_actions = actions;
                    
                }         
            })
        },

        enableScroller(){
            $body.style.removeProperty('overflow');
        },
        
        disableScroller(){
            $body.style.overflow = 'hidden';
        }
    }

}

</script>

<style scoped>
    
    .header {
        min-height: 16.428571429px;
        padding: 20px;
        border-bottom: 1px solid #e5e5e5;
    }
    
    .title{
        margin:0;
        line-height: 1.42857143;
    }
    

    .body {
        position: relative;
        padding: 20px;
    }
    
    .row {
        padding-left: 20px;
        position: relative;
        margin-left: -15px;
        margin-right: -15px;
        width: 100%
    }

    h4{
        font-size: 20px;
    }
    .items, .attachment{
        color: #0099ff;


    }
    .items:hover, .attachment:hover{
        text-decoration: underline;
    }
    table, td, th{
        border: 1px solid #dddddd;
    }
    table{
        border-collapse: collapse;
        width: 100%;
        margin-left: auto;
        margin-right: auto;
    }
    .column_rows{
        display: flex;

    }

    td, th{
        padding: 5px;
    }
    
    button{
        width: 100px;
    }
    
    @media only screen and (max-width: 543px) and (min-width: 375) , (min-device-width: 320px) and (max-device-width: 1024px){
        .header{
            padding: 8px;
        }
        table, td, th{
            border: 1px solid #dddddd;

        }
        table{
            border-collapse: collapse;
            width: 96vw;
            margin-left: auto;
            margin-right: auto;
        }
        .column_rows{
        display: flex;

        }
        .title{
        margin:0;
        line-height: 1.42857143;
        font-size: 25px;
        }
        h4{
            font-size: 20px;
        }
        .row{
            padding: 3px;
        }
    }
    
</style>



// WEBPACK FOOTER //
// src/components/job/stop-action/JobStopAction.vue